import { ArrowRight } from "lucide-react"
import { Link } from "react-router"

interface DashboardRowProps {
  title: React.ReactNode
  subtitle?: string
  metric: React.ReactNode
  metricLabel: string
  action?: { label: string; to: string }
  stateLabel?: string
}

export function DashboardRow({
  title,
  subtitle,
  metric,
  metricLabel,
  action,
  stateLabel,
}: DashboardRowProps) {
  return (
    <div className="flex items-baseline gap-3.5 border-t border-white/5 py-3.5 first:border-t-0">
      <span className="min-w-0">
        {title}
        {subtitle && (
          <span className="mt-1 block text-xs text-grey5">{subtitle}</span>
        )}
      </span>
      <span className="ml-auto whitespace-nowrap text-right text-xs tabular-nums text-grey5">
        <b className="block text-sm font-semibold text-white">{metric}</b>
        {metricLabel}
      </span>
      <span className="w-[108px] whitespace-nowrap text-right">
        {action ? (
          <Link
            to={action.to}
            className="inline-flex items-center gap-1 text-xs font-semibold text-white hover:underline"
          >
            {action.label}
            <ArrowRight size={13} />
          </Link>
        ) : (
          <span className="text-xs text-grey5">{stateLabel}</span>
        )}
      </span>
    </div>
  )
}
